const dynamicPricingResizer = () => {
    const dynamicPricingEl = document.querySelector('.ywdpd_popup.cart')

    if (dynamicPricingEl) {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 1000)
    }
}

export default (function () {
    dynamicPricingResizer()
})
